export const SampleProjects = [
    { 
      id: "P1001",
      name: "Website Redesign", 
      details: "Complete overhaul of company website with modern design and improved UX",
      dueDate: "2023-12-15",
      tasks: [
        { id: "T1001", name: "Conduct user research", details: "Survey 100 users about current website pain points", status: "notStarted", dueDate: "2023-06-01" },
        { id: "T1002", name: "Create wireframes", details: "Design low-fidelity wireframes for all key pages", status: "inProgress", dueDate: "2023-06-15" },
        { id: "T1003", name: "Develop homepage", details: "Code new homepage with responsive design", status: "completed", dueDate: "2023-07-01" },
        { id: "T1004", name: "Implement CMS integration", details: "Connect WordPress backend to new frontend", status: "notStarted", dueDate: "2023-07-15" },
        { id: "T1005", name: "Design product pages", details: "Create templates for 15 product categories", status: "dueDateOver", dueDate: "2023-07-20" },
        { id: "T1006", name: "Optimize for mobile", details: "Ensure all pages pass mobile usability tests", status: "notStarted", dueDate: "2023-08-01" },
        { id: "T1007", name: "Set up analytics", details: "Install Google Analytics with custom event tracking", status: "dueDateOver", dueDate: "2023-08-05" },
        { id: "T1008", name: "Create style guide", details: "Document all design system components", status: "notStarted", dueDate: "2023-08-10" },
        { id: "T1009", name: "Migrate existing content", details: "Transfer 500+ legacy pages to new structure", status: "notStarted", dueDate: "2023-09-01" },
        { id: "T1010", name: "Implement SEO improvements", details: "Apply on-page SEO best practices sitewide", status: "completed", dueDate: "2023-09-15" },
        { id: "T1011", name: "Test checkout flow", details: "Conduct usability testing on e-commerce functions", status: "notStarted", dueDate: "2023-10-01" },
        { id: "T1012", name: "Train content team", details: "Prepare documentation and training for CMS users", status: "notStarted", dueDate: "2023-10-15" },
        { id: "T1013", name: "Set up staging environment", details: "Prepare test server for client review", status: "completed", dueDate: "2023-10-20" },
        { id: "T1014", name: "Implement accessibility features", details: "Ensure WCAG 2.1 AA compliance", status: "completed", dueDate: "2023-11-01" },
        { id: "T1015", name: "Optimize page speed", details: "Achieve Google PageSpeed score of 90+", status: "notStarted", dueDate: "2023-11-05" },
        { id: "T1016", name: "Create 404 page", details: "Design custom error page with helpful navigation", status: "completed", dueDate: "2023-11-10" },
        { id: "T1017", name: "Set up email integration", details: "Connect contact forms to marketing automation", status: "completed", dueDate: "2023-11-15" },
        { id: "T1018", name: "Implement security measures", details: "Add SSL, firewall, and security plugins", status: "dueDateOver", dueDate: "2023-11-20" },
        { id: "T1019", name: "Plan launch campaign", details: "Coordinate with marketing for go-live announcement", status: "notStarted", dueDate: "2023-12-01" },
        { id: "T1020", name: "Post-launch review", details: "Schedule 30-day performance analysis meeting", status: "notStarted", dueDate: "2024-01-15" }
      ] 
    },
    { 
      id: "P1002",
      name: "Mobile App Development", 
      details: "Build cross-platform fitness tracking application",
      dueDate: "2023-11-30",
      tasks: [
        { id: "T2001", name: "Finalize feature list", details: "Confirm MVP features with stakeholders", status: "completed", dueDate: "2023-05-15" },
        { id: "T2002", name: "Set up React Native project", details: "Initialize codebase with required dependencies", status: "inProgress", dueDate: "2023-06-01" },
        { id: "T2003", name: "Design database schema", details: "Create Firebase data structure for user profiles", status: "notStarted", dueDate: "2023-06-15" },
        { id: "T2004", name: "Implement user authentication", details: "Add email/password and social login options", status: "notStarted", dueDate: "2023-07-01" },
        { id: "T2005", name: "Build workout tracking UI", details: "Create main exercise logging interface", status: "notStarted", dueDate: "2023-07-15" }
      ] 
    },
    { 
      id: "P1003",
      name: "CRM Migration", 
      details: "Transition from legacy CRM to Salesforce platform",
      dueDate: "2023-10-31",
      tasks: [
        { id: "T3001", name: "Export existing customer data", details: "Extract all records from current system", status: "inProgress", dueDate: "2023-06-10" },
        { id: "T3002", name: "Map data fields", details: "Create transformation rules for data migration", status: "notStarted", dueDate: "2023-06-25" },
        { id: "T3003", name: "Configure Salesforce instance", details: "Set up organizational structure and permissions", status: "notStarted", dueDate: "2023-07-10" },
        { id: "T3004", name: "Train sales team", details: "Schedule 3 training sessions for all users", status: "notStarted", dueDate: "2023-09-01" },
        { id: "T3005", name: "Validate migrated data", details: "QA check 10% of records for accuracy", status: "notStarted", dueDate: "2023-10-15" }
      ] 
    },
    { 
      id: "P1004",
      name: "Inventory Management System", 
      details: "Develop custom solution for warehouse operations",
      dueDate: "2024-01-31",
      tasks: [
        { id: "T4001", name: "Document current processes", details: "Interview warehouse staff about workflows", status: "completed", dueDate: "2023-05-20" },
        { id: "T4002", name: "Select barcode hardware", details: "Research and choose scanning devices", status: "inProgress", dueDate: "2023-06-15" },
        { id: "T4003", name: "Design receiving module", details: "Create UI for inventory intake process", status: "notStarted", dueDate: "2023-07-01" },
        { id: "T4004", name: "Build reporting dashboard", details: "Implement real-time stock level displays", status: "notStarted", dueDate: "2023-09-01" },
        { id: "T4005", name: "Integrate with accounting software", details: "Connect to QuickBooks API", status: "notStarted", dueDate: "2023-12-15" }
      ] 
    },
    { 
      id: "P1005",
      name: "Marketing Automation", 
      details: "Implement HubSpot for lead nurturing campaigns",
      dueDate: "2023-09-30",
      tasks: [
        { id: "T5001", name: "Segment contact database", details: "Create buyer persona groupings", status: "completed", dueDate: "2023-05-01" },
        { id: "T5002", name: "Design email templates", details: "Create 5 responsive email layouts", status: "inProgress", dueDate: "2023-06-01" },
        { id: "T5003", name: "Build lead scoring model", details: "Define criteria for marketing-qualified leads", status: "notStarted", dueDate: "2023-07-01" },
        { id: "T5004", name: "Set up nurture sequences", details: "Create 3 automated email workflows", status: "notStarted", dueDate: "2023-08-01" },
        { id: "T5005", name: "Integrate with website forms", details: "Connect all lead capture points", status: "notStarted", dueDate: "2023-09-01" }
      ] 
    },
    { 
      id: "P1006",
      name: "Data Warehouse Implementation", 
      details: "Build centralized analytics platform",
      dueDate: "2024-03-31",
      tasks: [
        { id: "T6001", name: "Assess data sources", details: "Catalog all existing databases and feeds", status: "inProgress", dueDate: "2023-07-01" },
        { id: "T6002", name: "Design dimensional model", details: "Create star schema for analytics", status: "notStarted", dueDate: "2023-08-15" },
        { id: "T6003", name: "Set up ETL pipelines", details: "Build data extraction processes", status: "notStarted", dueDate: "2023-10-01" },
        { id: "T6004", name: "Configure BI tool connection", details: "Connect Tableau to warehouse", status: "notStarted", dueDate: "2024-01-15" },
        { id: "T6005", name: "Create documentation", details: "Write technical specs and user guides", status: "notStarted", dueDate: "2024-03-01" }
      ] 
    },
    { 
      id: "P1007",
      name: "Office Relocation", 
      details: "Move company headquarters to new building",
      dueDate: "2023-08-31",
      tasks: [
        { id: "T7001", name: "Hire moving company", details: "Get quotes from 3 vendors", status: "completed", dueDate: "2023-05-15" },
        { id: "T7002", name: "Plan seating chart", details: "Assign workspaces for 75 employees", status: "inProgress", dueDate: "2023-06-01" },
        { id: "T7003", name: "Coordinate IT infrastructure", details: "Schedule internet and phone setup", status: "notStarted", dueDate: "2023-07-15" },
        { id: "T7004", name: "Organize packing schedule", details: "Create department-by-department timeline", status: "notStarted", dueDate: "2023-07-30" },
        { id: "T7005", name: "Update business licenses", details: "File address change with all agencies", status: "notStarted", dueDate: "2023-08-15" }
      ] 
    },
    { 
      id: "P1008",
      name: "Employee Training Program", 
      details: "Develop comprehensive skills development initiative",
      dueDate: "2023-12-31",
      tasks: [
        { id: "T8001", name: "Conduct skills assessment", details: "Survey all departments about training needs", status: "inProgress", dueDate: "2023-06-30" },
        { id: "T8002", name: "Select LMS platform", details: "Evaluate 3 learning management systems", status: "notStarted", dueDate: "2023-07-31" },
        { id: "T8003", name: "Develop leadership curriculum", details: "Create 5 management training modules", status: "notStarted", dueDate: "2023-09-30" },
        { id: "T8004", name: "Schedule first workshops", details: "Arrange dates for Q3 training sessions", status: "notStarted", dueDate: "2023-10-31" },
        { id: "T8005", name: "Create evaluation metrics", details: "Define KPIs for program success", status: "notStarted", dueDate: "2023-11-30" }
      ] 
    },
    { 
      id: "P1009",
      name: "Product Launch", 
      details: "Introduce new IoT home device to market",
      dueDate: "2023-11-15",
      tasks: [
        { id: "T9001", name: "Finalize packaging design", details: "Approve box artwork and materials", status: "completed", dueDate: "2023-06-01" },
        { id: "T9002", name: "Coordinate with manufacturers", details: "Confirm production timeline", status: "inProgress", dueDate: "2023-07-01" },
        { id: "T9003", name: "Plan press release", details: "Draft announcement and media list", status: "notStarted", dueDate: "2023-09-01" },
        { id: "T9004", name: "Organize launch event", details: "Book venue and send invitations", status: "notStarted", dueDate: "2023-10-15" },
        { id: "T9005", name: "Prepare support materials", details: "Create FAQ and troubleshooting docs", status: "notStarted", dueDate: "2023-11-01" }
      ] 
    },
    { 
      id: "P1010",
      name: "Security Audit", 
      details: "Comprehensive review of IT systems and policies",
      dueDate: "2023-09-15",
      tasks: [
        { id: "T10001", name: "Conduct vulnerability scans", details: "Run penetration tests on all systems", status: "notStarted", dueDate: "2023-07-01" },
        { id: "T10002", name: "Review access controls", details: "Audit user permissions and roles", status: "notStarted", dueDate: "2023-07-15" },
        { id: "T10003", name: "Update incident response plan", details: "Revise security protocols", status: "notStarted", dueDate: "2023-08-01" },
        { id: "T10004", name: "Train staff on phishing", details: "Conduct simulated attack exercise", status: "notStarted", dueDate: "2023-08-15" },
        { id: "T10005", name: "Implement MFA", details: "Roll out multi-factor authentication company-wide", status: "notStarted", dueDate: "2023-09-01" }
      ] 
    }
  ]

 
export const STATUS_COLORS: { [key: string]: string } = {
    completed: 'green',
    dueDateOver: 'red',
    warning: 'orange',
    inProgress: 'blue',
    notStarted: 'gray',
};


export const ClientSampleData = [
 {
      id: "CL1001",
      name: "TechNova Solutions",
      website: "www.technovasolutions.com",
      phone: "+1 (415) 555-1234",
      linkedIn: "linkedin.com/company/technova-solutions",
      addressField1: "200 Tech Park Drive",
      addressField2: "Suite 450",
      city: "San Francisco",
      state: "CA",
      zipCode: "94107",
      country: "United States",
      contactName: "Sarah Johnson",
      contactEmail: "s.johnson@technovasolutions.com",
      contactPhone: "+1 (415) 555-5678",
      contactLinkedIn: "linkedin.com/in/sarahj-tech",
      salesperson: "Michael Chen",
      value: "client1",
      icon:'reconciliation',
      type:'client',
      label: "TechNova Solutions"
    }, {
      id: "CL1002",
      name: "Global Retail Partners",
      website: "www.globalretailpartners.co.uk",
      phone: "+44 20 7946 0958",
      linkedIn: "linkedin.com/company/global-retail-partners",
      addressField1: "15 Oxford Street",
      addressField2: "3rd Floor",
      city: "London",
      state: "",
      zipCode: "W1D 1BH",
      country: "United Kingdom",
      contactName: "David Wilson",
      contactEmail: "d.wilson@grp.co.uk",
      contactPhone: "+44 77 1234 5678",
      contactLinkedIn: "linkedin.com/in/davidwilson-retail",
      salesperson: "Emma Rodriguez",
      value: "client2",
      icon:'project',
      type:'task',
      label: "Global Retail Partners"
    },
   {
        id: "CL1003",
        name: "GreenEarth Innovations",
        website: "www.greenearth.eco",
        phone: "+1 (604) 555-7890",
        linkedIn: "linkedin.com/company/greenearth-innovations",
        addressField1: "800 Sustainability Way",
        addressField2: "Building C",
        city: "Vancouver",
        state: "BC",
        zipCode: "V6B 1S9",
        country: "Canada",
        contactName: "Priya Patel",
        contactEmail: "priya.patel@greenearth.eco",
        contactPhone: "+1 (604) 555-2345",
        contactLinkedIn: "linkedin.com/in/priyapatel-sustainability",
        salesperson: "James Wilson",
        value: "client3",
        icon:'reconciliation',
        type:'project',
        label: "GreenEarth Innovations"
      },
      {
        id: "CL1004",
        name: "FinTech Capital",
        website: "www.fintechcapital.io",
        phone: "+1 (212) 555-6789",
        linkedIn: "linkedin.com/company/fintech-capital-ny",
        addressField1: "55 Wall Street",
        addressField2: "Floor 22",
        city: "New York",
        state: "NY",
        zipCode: "10005",
        country: "United States",
        contactName: "Robert Zhang",
        contactEmail: "robert.zhang@fintechcapital.io",
        contactPhone: "+1 (917) 555-3456",
        contactLinkedIn: "linkedin.com/in/robertzhang-fintech",
        salesperson: "Lisa Thompson",
        value: "client4",
        icon:'apartment',
        type:'client',
        label: "FinTech Capital"
      },{
          id: "CL1003",
          name: "GreenEarth Innovations",
          website: "www.greenearth.eco",
          phone: "+1 (604) 555-7890",
          linkedIn: "linkedin.com/company/greenearth-innovations",
          addressField1: "800 Sustainability Way",
          addressField2: "Building C",
          city: "Vancouver",
          state: "BC",
          zipCode: "V6B 1S9",
          country: "Canada",
          contactName: "Priya Patel",
          contactEmail: "priya.patel@greenearth.eco",
          contactPhone: "+1 (604) 555-2345",
          contactLinkedIn: "linkedin.com/in/priyapatel-sustainability",
          salesperson: "James Wilson",
          value: "client3",
          icon:'project',
          type:'project',
          label: "GreenEarth Innovations"
        },
        {
          id: "CL1005",
          name: "MediCare Systems Australia",
          website: "www.medicare-systems.com.au",
          phone: "+61 2 9876 5432",
          linkedIn: "linkedin.com/company/medicare-systems-au",
          addressField1: "100 Health Plaza",
          addressField2: "North Tower",
          city: "Sydney",
          state: "NSW",
          zipCode: "2000",
          country: "Australia",
          contactName: "Olivia Brown",
          contactEmail: "olivia.brown@medicare-systems.com.au",
          contactPhone: "+61 4 1234 5678",
          contactLinkedIn: "linkedin.com/in/oliviabrown-healthtech",
          salesperson: "Daniel Kim",
          value: "client5",
          icon:'reconciliation',
          type:'task',
          label: "MediCare Systems Australia"
        },
    
  ];